<template>
  <ul
    v-if="configData.isVisible"
    class="context-menu"
    :style="{ left: configData.x + 'px', top: configData.y + 'px' }"
  >
    <li v-if="configData.modifyKey === 'row'" @click="modifyRow()">
      Modify Row
    </li>
    <li v-else @click="modifyColumn()">Modify Column</li>
  </ul>
</template>
<script>
export default {
  props: {
    config: {
      type: Object,
    },
    onHandleRightClickRow: {
      type: Function,
    },
    onHandleRightClickCell: {
      type: Function,
    },
  },
  data() {
    return {
      configData: {},
    };
  },
  watch: {
    config: function() {
      this.configData = this.config;
    },
  },
  created() {
    this.configData = this.config;
  },
  methods: {
    modifyRow() {
      this.configData.isVisible = false;
      this.onHandleRightClickRow(this.config.data);
    },
    modifyColumn() {
      this.onHandleRightClickCell(this.config.data);
    },
  },
};
</script>

<style lang="scss"></style>
